// extracted by mini-css-extract-plugin
export default {"price":"m9-z","onSale":"n9-z","msrpLabelPrice":"o9-z","msrpLabel":"p9-z","originalPrice":"q9-z","percentOff":"r9-z"};